module.exports = __webpack_public_path__ + "media/images/products/blog-mobile-b6946fa6408b24446f86a4629ef0185f.png";